import { AppointmentStatus, Timezone } from '@bb/domain/dist/types';
import { Space, Text } from 'components';
import React from 'react';
import { formatTimeStr } from 'utils';
import DotOrCheckbox from './DotOrCheckbox';

export interface TimeEntryProps {
  needsAction?: boolean;
  showEnd?: boolean;
  time: string;
  timezone: Timezone | undefined;
  timeEnd?: string;
  status?: AppointmentStatus;
  passed?: boolean;
  isMobile?: boolean;
  appointmentId?: string;
}

const TimeEntry: React.FC<TimeEntryProps> = ({
  needsAction,
  showEnd = true,
  time,
  timezone,
  timeEnd,
  status,
  passed,
  isMobile,
  appointmentId,
}) => {
  let text = formatTimeStr(time, timezone);
  if (showEnd) {
    text += ` - ${formatTimeStr(timeEnd!, timezone)}`;
  }
  return (
    <Space align="center" size={12}>
      <DotOrCheckbox
        appointmentId={appointmentId}
        isMobile={isMobile}
        dotVisible={needsAction}
        status={status}
        passed={passed}
      />
      <Text block strong={needsAction}>
        {text}
      </Text>
    </Space>
  );
};

export default TimeEntry;
